<template>
    <div class="checklist analysis">
        <div class="item card" v-for="(item, index) in checklistContent.item" :key="item.id">
            <span class="item-title">
                {{ index + 1 }}.
                {{ item.text }}
            </span>
            <ChecklistResponse
                :response="getChecklistResponse(item.id)"
            ></ChecklistResponse>
        </div>
    </div>
</template>

<script>
import CardAnalysis from '../../component/analysis'

import ChecklistResponse from './Response'

export default {
    name: 'checklist-card-analysis',
    extends: CardAnalysis,

    props: {
        checklists: {
            type: Array,
            required: true
        },
        id: {
            type: String,
            required: true
        }
    },

    methods: {
        getChecklistResponse(id) {

            return this.checklists.map((checklist) => ({
                response: checklist.item ? checklist.item.find((item) => item.id === id) : {},
                time: this.formatDate(checklist.time),
                isHistory: checklist.time < new Date().setHours(24, 0, 0, 0)
            }))
        }
    },

    computed: {
        /**
         * Get checklist content object for the checklist id
         */
        checklistContent() {
            return this.getContent('checklist', this.id.split(':')[0])
        }

    },

    components: {
        ChecklistResponse
    }

}
</script>

<style lang="scss" scoped>
@import "../../component/table/style/analysis.scss";
.analysis .item.card{
    padding: 0px;
}
.item-title{
    margin: 12px 14px;
    font-weight: 700;
    max-width: 750px;
    display: inline-block;
}
</style>
